export const Cardinfo = [
  {
    title: 'Transform Your Business with Scalable Cloud Solutions',
    description:
      'Leverage our cloud expertise to enhance flexibility, reduce infrastructure costs, and scale seamlessly. Our tailored cloud strategies deliver performance, reliability, and security to empower your digital transformation journey across all platforms.',
  },
  {
    title: 'Secure Your Digital Infrastructure',
    description:
      'Protect your systems with real-time threat monitoring, data encryption, and compliance-ready cybersecurity strategies designed to keep your business safe and resilient.',
  }, // ≈150 characters
  {
    title: 'Accelerate Innovation with Custom Software',
    description:
      'We build high-performance apps that solve your unique business challenges and drive innovation at scale.',
  }, // ≈100 characters
];

  export const cardVariants = {
  hidden: { opacity: 0, y: 200 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.1,
      ease: "easeOut",
    },
  },
};